// @ts-ignore
import * as XLSX from 'xlsx';

/**
 * Creates a product template Excel file for customers to download
 */
export function createProductTemplate(): Blob {
  // Define the headers for the template
  const headers = [
    'Brand', 
    'Type', 
    'Collab', 
    'Colorway', 
    'Size', 
    'SizeType', 
    'Condition', 
    'Price', 
    'OGBox',
    'Description'
  ];
  
  // Create example data rows
  const exampleData = [
    {
      'Brand': 'Nike',
      'Type': 'Air Jordan 1',
      'Collab': 'Off-White',
      'Colorway': 'UNC',
      'Size': '9',
      'SizeType': 'M',
      'Condition': 'New/Deadstock',
      'Price': 2500,
      'OGBox': 'Yes',
      'Description': 'Limited edition collaboration between Nike and Off-White. Features iconic deconstructed design.'
    },
    {
      'Brand': 'Adidas',
      'Type': 'Yeezy Boost 350',
      'Collab': '',
      'Colorway': 'Zebra',
      'Size': '7',
      'SizeType': 'W',
      'Condition': 'Used - Excellent',
      'Price': 220,
      'OGBox': 'No',
      'Description': 'Adidas Yeezy Boost 350 V2 in the iconic Zebra colorway. Minor wear on outsoles.'
    },
    {
      'Brand': 'Nike',
      'Type': 'Air Jordan 4',
      'Collab': 'Travis Scott',
      'Colorway': 'Cactus Jack',
      'Size': '5Y',
      'SizeType': 'GS',
      'Condition': 'New/Deadstock',
      'Price': 1200,
      'OGBox': 'Yes',
      'Description': 'Travis Scott collaboration featuring blue suede upper and red details. Includes original box and laces.'
    }
  ];
  
  // Create a new workbook
  const workbook = XLSX.utils.book_new();
  
  // Convert our data to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(exampleData, { header: headers });
  
  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Products');
  
  // Create styles - highlighting the headers
  // Set column widths (this is a bit of a hack in XLSX)
  const colWidths = headers.map(h => ({ wch: Math.max(h.length * 1.5, 10) }));
  worksheet['!cols'] = colWidths;
  
  // Add a note to explain the template
  const helpText = [
    { 'Instructions': 'Fill in the product details below. All columns except Collab and Description are required.' },
    { 'Instructions': 'Brand - The product brand (e.g., Nike, Adidas, Jordan)' },
    { 'Instructions': 'Type - The product model/style (e.g., Air Jordan 1, Yeezy Boost 350)' },
    { 'Instructions': 'Collab - Optional collaboration name (e.g., Travis Scott, Off-White)' },
    { 'Instructions': 'Colorway - The product color scheme (e.g., Bred, UNC, Zebra)' },
    { 'Instructions': 'Size - The numeric shoe size (e.g., 9, 10, 10.5, 5Y, 3C)' },
    { 'Instructions': 'SizeType - The size standard (M=Men\'s, W=Women\'s, GS=Grade School, TD=Toddler)' }, 
    { 'Instructions': 'Condition - The product condition (e.g., New/Deadstock, Used - Excellent, Used - Good)' },
    { 'Instructions': 'Price - The product price in USD (e.g., 220, 1200, 2500)' },
    { 'Instructions': 'OGBox - Whether the product includes the original box (Yes/No)' },
    { 'Instructions': 'Description - Optional detailed description of the product' },
    { 'Instructions': '' },
  ];
  
  // Create a help worksheet
  const helpSheet = XLSX.utils.json_to_sheet(helpText);
  XLSX.utils.book_append_sheet(workbook, helpSheet, 'Instructions');
  
  // Write the workbook to a binary string
  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
  
  // Convert the binary string to a Blob
  function s2ab(s: string): ArrayBuffer {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }
  
  const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
  return blob;
} 